import styled from 'styled-components';

export const StyledBetaModal = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.themeColors.beta.modal.background};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.themeColors.beta.modal.borderColor};
  box-shadow: 2px 4px 8px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  left: 50%;
  max-height: 460px;
  min-width: 780px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
`;

export const StyledOverlay = styled.div`
  background-color: rgba(29, 29, 31, 0.5);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10000;
`;

export const StyledBetaModalHeader = styled.div`
  border-bottom: 1px solid
    ${({ theme }) => theme.themeColors.beta.modal.borderColor};
  display: flex;
  font-size: 1.125rem;
  padding: 1em 2em;
  width: 100%;
`;

export const StyledBetaModalContent = styled.div`
  font-size: 1rem;
  overflow-y: auto;
  padding: 0.25rem 2rem;
`;

export const StyledBetaModalFooter = styled.div`
  align-items: center;
  border-top: 1px solid
    ${({ theme }) => theme.themeColors.beta.modal.borderColor};
  display: flex;
  justify-content: space-between;
  padding: 1.25rem 2rem;
  width: 100%;

  > small {
    color: ${({ theme }) => theme.themeColors.beta.modal.smallTextColor};
  }

  > button {
    appearance: none;
    background: ${({ theme }) => theme.themeColors.beta.modal.buttonBackground};
    border-radius: 4px;
    border: 0;
    cursor: pointer;
    font-family: inherit;
    font-size: 1rem;
    padding: 0.75em 2.5em;

    &:hover {
      background: ${({ theme }) => theme.genericColors.orangeZest};
    }
  }
`;
